<script lang="ts">
	import type { BaseProduct, FullProduct } from '$lib/js/elasticsearch/types'
	import { getProductFinalPriceWithTax } from '$lib/js/helpers'
	import { getDeliveryEstimatedDate } from '$lib/js/products'
	import { t } from 'svelte-i18n-lingui'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let type = '' // "" | product
	export let product: BaseProduct | FullProduct

	const scope = getContextScope()

	let dates = getDeliveryEstimatedDate({ scope: scope })
	let price = getProductFinalPriceWithTax(product)

	if (type === 'product') {
		dates = getDeliveryEstimatedDate({ start: 2, end: 3, type: 'short', scope: scope })
	}

	/* Times notice */
	// let isHovered = false;
	// $: uClass = isHovered === true ? 'visible' : ''
</script>


<div class="delivery-times {type}">
	<!-- <p>
		<button
			class="help"
			on:mouseover={() => isHovered = true}
			on:focus={() => isHovered = true}
			on:mouseout={() => isHovered = false}
			on:blur={() => isHovered = false}
		>
			<span class="icon icon-help"></span> Entrega prevista:
			<div class="notice {uClass}">
				<p>La fecha indicada es una estimación que podría variar según la agencia de transporte.
				<br><br>Recuerda que durante estas fechas tan señaladas el volumen de carga de las agencias de transporte es muy elevado y puede generar alguna demora adicional.</p>
			</div>
		</button>
	</p> -->
	<!-- {#if updatedDates}
		<p>{$t`Estimated delivery:`} <b>{updatedDates?.start}</b> - <b>{updatedDates?.end}</b></p>
	{:else} -->
	{#if product && price >= 69}
		<p>{$t`Free shipping:`} <b>{dates.start}</b> - <b>{dates.end}</b></p>
	{:else}
		<p>{$t`Estimated delivery:`} <b>{dates.start}</b> - <b>{dates.end}</b></p>
	{/if}
	<!-- {/if} -->
</div>


<style lang="scss">
  .delivery-times {
    position: relative;
    margin-top: 6px;
    margin-bottom: 25px;

    &.product {
      margin: 0;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    // > p {
    //   display: inline-block;
    // }

    // button.help {
    //   span {
    //     font-size: 16px;
    //     margin-right: 3px;
    //   }
    // }

    // .notice {
    //   font-size: 14px;
    //   visibility: hidden;
    //   opacity: 0;
    //   pointer-events: none;
    //   position: absolute;
    //   background: white;
    //   padding: 20px;
    //   z-index: 1;
    //   border-radius: 5px;
    //   left: 0;
    //   top: calc(100% + 10px);
    //   box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.06);
    //   text-align: left;
    //   cursor: default;

    //   &.visible {
    //     visibility: visible;
    //     opacity: 1;
    //     pointer-events: all;
    //   }
    // }
  }
</style>
